module.exports = __webpack_public_path__ + "img/noun-work-in-progress-215093.ee59ef57.svg";